import {useUpmPlant} from '@hconnect/upm'
import {Button} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {ShutdownStatus} from '@refra/modules/common/enums'
import {useKilns, useShutdowns} from '@refra/modules/common/providers'
import {useEditShutdownStatus} from '@refra/modules/refra-planning/hooks/mutations'
import {useUrlParam} from '@refra/modules/routing/hooks'
export const StaticPartDetailShutdownStatusSwitch = () => {
  const {selectedShutdown} = useShutdowns()
  const {t} = useTranslation()
  const plantId = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId})
  const {selectedKiln} = useKilns()
  const isDraft = selectedShutdown?.shutdownStatus === ShutdownStatus.Draft
  const {mutate: editShutdownStatus} = useEditShutdownStatus()

  const onShutdownStatusChange = (status: ShutdownStatus) => {
    if (selectedShutdown?.id === undefined) return

    return editShutdownStatus({
      plantUpmId: upmPlant.upmId,
      kilnUpmId: selectedKiln.upmId,
      shutdownId: selectedShutdown.id,
      status
    })
  }

  return (
    <Button
      size="large"
      variant="secondary"
      onClick={() =>
        onShutdownStatusChange(isDraft ? ShutdownStatus.Finalized : ShutdownStatus.Draft)
      }
    >
      {t(`staticParts.replacementDetail.${isDraft ? 'closeShutdown' : 'reopenShutdown'}`)}
    </Button>
  )
}
